import types from "./actionTypes";

// Activity Report
export const fetchEmployeeActivityReport = (payload) => ({
  type: types.FETCH_EMPLOYEE_ACTIVITY_REPORT_REQUEST,
  payload,
});

// My Activity Report
export const fetchMyActivityReport = (payload) => ({
  type: types.FETCH_MY_ACTIVITY_REPORT_REQUEST,
  payload,
});

// Age Wise Report
export const fetchAgeWiseReport = (payload) => ({
  type: types.FETCH_AGE_WISE_REPORT_REQUEST,
  payload,
});

// Birthday Report
export const fetchBirthdayReport = (payload) => ({
  type: types.FETCH_BIRTHDAY_REPORT_REQUEST,
  payload,
});

// Exemption / Resigned Report
export const fetchExemptionResignedReport = (payload) => ({
  type: types.FETCH_EXEMPTION_RESIGNED_REPORT_REQUEST,
  payload,
});

export const resetEmployeeReport = () => ({
  type: types.RESET_EMPLOYEE_REPORT,
});